import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

// Fetches every requested scratch plate's metadata layer data frame in a single request, so the
// "put in inventory" modal can compute the union of ad hoc plate-level field names across a whole
// batch of schema-less plates without one round trip per plate. $limit is 1 since a plate field's
// value is duplicated onto every well row — any single row carries it.
//
// eslint doesn't recognize that $limit/$offset/$sortInput are used within the PersistedDataFrameGraphQL
// fragment
export const GET_SCRATCH_PLATES_PLATE_FIELDS_QUERY = gql`
  query GetScratchPlatesPlateFields(
    $ids: [StrictString!]!
    $limit: StrictInt!
    $offset: StrictInt = 0
    $sortInput: DataFrameSortInput
  ) @skipAudit @engComponent(name: NOTEBOOK) {
    scratchPlates(ids: $ids) {
      ... on ScratchPlateNode {
        id
        layers {
          name
          dataFrame {
            ...InaccessibleInfoGraphQL
            ...PersistedDataFrameGraphQL
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
  ${getFragmentWrapper('PersistedDataFrame').fragment}
`;
